'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsCarousel = function () {
  function ProductsCarousel(el) {
    (0, _classCallCheck3.default)(this, ProductsCarousel);

    this.els = {
      el: el,
      slides: (0, _functional.getElement)('.prd-Carousel_Items', { context: el }),
      dots: (0, _functional.getElement)('.prd-Carousel_Dots', { context: el }),
      controls: (0, _functional.getElement)('.prd-Carousel_Controls', { context: el }),
      prevControl: (0, _functional.getElement)('.prd-Carousel_Control-prev', { context: el }),
      nextControl: (0, _functional.getElement)('.prd-Carousel_Control-next', { context: el }),
      addAllItems: (0, _functional.getElement)('[data-add-all-items]', { context: el })
    };

    this.productsPerSlide = Number.parseInt(this.els.el.dataset.productsPerSlide, 10);

    this.initializeCarousel();
  }

  (0, _createClass3.default)(ProductsCarousel, [{
    key: 'initializeCarousel',
    value: function initializeCarousel() {
      var _perPage,
          _this = this;

      this.carousel = new _siema2.default({
        selector: this.els.slides,
        duration: 500,
        perPage: (_perPage = {}, (0, _defineProperty3.default)(_perPage, _utils.mediaBreakpoints.sm, 2), (0, _defineProperty3.default)(_perPage, _utils.mediaBreakpoints.md, this.productsPerSlide), _perPage),
        onChange: function onChange() {
          if (!_this.dotEls) return;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _this.dotEls.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref = _step.value;

              var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

              var index = _ref2[0];
              var dotEl = _ref2[1];

              dotEl.setAttribute('aria-current', String(index === _this.carousel.currentSlide));
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });

      this.initialiseDots();
      this.initialiseControls();
      this.initialiseAddAllItems();
    }
  }, {
    key: 'initialiseAddAllItems',
    value: function initialiseAddAllItems(carousel) {
      if (!this.els.addAllItems) return;

      this.handleAddAllItemsClick = this.handleAddAllItemsClick.bind(this);

      this.els.addAllItems.addEventListener('click', this.handleAddAllItemsClick);
    }
  }, {
    key: 'initialiseDots',
    value: function initialiseDots() {
      var _this2 = this;

      this.amountOfDotsWanted = this.carousel.innerElements.length - (this.carousel.perPage - 1);

      if (!this.els.dots) return;

      this.dotEls = (0, _functional.range)(this.amountOfDotsWanted).map(function (index) {
        return (0, _functional.createElement)('div', {
          class: 'prd-Carousel_Dot',
          'aria-current': String(index === _this2.carousel.currentSlide),
          onclick: function onclick() {
            return _this2.carousel.goTo(index);
          }
        });
      }).map(function (el) {
        return _this2.els.dots.appendChild(el);
      });
    }
  }, {
    key: 'initialiseControls',
    value: function initialiseControls() {
      var _this3 = this;

      var updateControlsState = function updateControlsState() {
        var className = 'prd-Carousel_Control-disabled';
        _this3.els.prevControl.classList.toggle(className, _this3.carousel.currentSlide === 0);
        _this3.els.nextControl.classList.toggle(className, _this3.carousel.currentSlide === _this3.amountOfDotsWanted - 1);
      };

      updateControlsState();

      this.els.prevControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.carousel.prev();

              case 2:
                updateControlsState();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      })));

      this.els.nextControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.carousel.next();

              case 2:
                updateControlsState();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      })));
    }
  }, {
    key: 'handleAddAllItemsClick',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var slideEls, variantIds;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                slideEls = this.els.slides.querySelectorAll('[data-product-item]');
                variantIds = Array.from(slideEls).map(function (slideEl) {
                  var productForm = slideEl.querySelector('form.js-AddToCart input[name="id"]');
                  return Number.parseInt(productForm.value);
                });
                _context3.prev = 2;
                _context3.next = 5;
                return window.PushCart.addItems(variantIds.map(function (id) {
                  return { id: id, quantity: 1 };
                }));

              case 5:

                window.drawers.activeDrawerKey = 'cart';
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](2);

                console.error('Error adding items to cart:', _context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));

      function handleAddAllItemsClick() {
        return _ref5.apply(this, arguments);
      }

      return handleAddAllItemsClick;
    }()
  }]);
  return ProductsCarousel;
}();

exports.default = ProductsCarousel;